import React from "react";
import { ParticipantFilesContext } from "../context/participantFilesContext";
import { IFile } from "../interface/iFile";
import { IUploads } from "../interface/iUploads";
import RenderHeadline from "./renderHeadline";
import UploadTile from "./uploadTile";

const ParticipantUploads = (): React.JSX.Element => {
  const {
    uploads,
  }: {
    uploads: IUploads;
  } = React.useContext(ParticipantFilesContext);

  return (
    <React.Fragment>
      <RenderHeadline text={"Von Dir hochgeladene Unterlagen"} />

      {uploads.files.uploadParticiopant.map((file: IFile) => (
        <UploadTile deletable={true} key={file.id} file={file} />
      ))}
    </React.Fragment>
  );
};

export default ParticipantUploads;
